var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input-style",attrs:{"id":_vm.inId,"type":_vm.inType,"placeholder":_vm.inText}})}
var staticRenderFns = []

export { render, staticRenderFns }